(function () {
  /* COY: matches the Recent Articles (blog-posts) slider — same card counts with a
     peek of the next card at each breakpoint, same slow 1s glide, trackpad swipe. */
  let scrollbarSettings = {
    slidesPerView: 1.1,
    spaceBetween: 16,
    allowTouchMove: true,
    /* COY (4 NOV): a touch more responsive — a shorter drag or flick moves to the next card,
       and the cards follow the finger slightly faster. */
    threshold: 3,
    touchRatio: 1, /* COY (4 NOV): 1:1 with the finger reads smoother than 1.15 */
    resistanceRatio: 0.6, /* softer stretch at the first/last card */
    longSwipesRatio: 0.3,
    speed: 900, /* COY (4 NOV): was 800; longer, smoother settle */
    mousewheel: {
      forceToAxis: true,
    },
    breakpoints: {
      767: {
        slidesPerView: 2.1,
      },
      900: {
        slidesPerView: 3.1,
      },
      1441: {
        slidesPerView: 4.1,
      },
      2200: {
        slidesPerView: 5.1,
      },
      2800: {
        slidesPerView: 6.1,
      },
    },
  };

  /* COY (4 NOV): phones use the exact same swipe as the Recent Articles slider — one card
     with a peek of the next (1.1), same 16px gap, same 1s glide, trackpad swipe — instead of
     the old free-width "auto" cards, so the product rows respond to a swipe the same way. */
  let sliderSettings = {
    slidesPerView: 1.1,
    spaceBetween: 16,
    allowTouchMove: true,
    /* COY (4 NOV): a touch more responsive — a shorter drag or flick moves to the next card,
       and the cards follow the finger slightly faster. */
    threshold: 3,
    touchRatio: 1, /* COY (4 NOV): 1:1 with the finger reads smoother than 1.15 */
    resistanceRatio: 0.6, /* softer stretch at the first/last card */
    longSwipesRatio: 0.3,
    speed: 900, /* COY (4 NOV): was 800; longer, smoother settle */
    mousewheel: {
      forceToAxis: true,
    },
  };

  const initSliders = (section, settings) => {
    const swiperEls = section.querySelectorAll(".products-tabs__layout");

    swiperEls.forEach((swiperEl) => {
      const swiperWrapper = swiperEl.querySelector(".products-tabs__list");
      const slides = swiperEl.querySelectorAll(".products-tabs__item");

      if (!swiperWrapper || !slides || !slides.length) return;


      swiperEl.classList.add("swiper");
      swiperWrapper.classList.add("swiper-wrapper");
      slides.forEach((slide, index) => {
        slide.classList.add("swiper-slide");
        let coeff = slides.length > 12 ? 0.05 : 0.1;

        if (slides.length > 24) {
          coeff = 0.02;
        }

        const delay = index * coeff;
        slide.style.setProperty("--prod-tabs-item-delay", `${delay}s`);
      });

      const progressBar = swiperEl.querySelector(".swiper-scrollbar");
      const nextBtn = swiperEl.querySelector(
        ".products-tabs__navigation-button-next"
      );
      const prevBtn = swiperEl.querySelector(
        ".products-tabs__navigation-button-prev"
      );

      scrollbarSettings = {
        ...scrollbarSettings,
        scrollbar: {
          el: progressBar,
          grabCursor: true,
          draggable: true,
          hide: false,
        },
      };

      sliderSettings = {
        ...sliderSettings,
        navigation:
          nextBtn && prevBtn
            ? {
                nextEl: nextBtn,
                prevEl: prevBtn,
                disabledClass: "swiper-button-disabled",
              }
            : false,
      };

      const swiper = new Swiper(
        swiperEl,
        settings === "bar" ? scrollbarSettings : sliderSettings
      );

      /* COY: open the row out to full page width after the first swipe/drag/scroll. */
      swiper.on("progress", (s, progress) => {
        if (progress > 0) expandToFullWidth(section);
        swiperEl.classList.toggle("products-tabs__layout--end", s.isEnd);
      });
      swiperEl.classList.toggle("products-tabs__layout--end", swiper.isEnd);
    });
  };

  const updateBleed = (section) => {
    const root = section.querySelector(".products-tabs");
    const layout = section.querySelector(".products-tabs__layout.active") ||
      section.querySelector(".products-tabs__layout");
    if (!root || !layout) return;
    const rect = layout.getBoundingClientRect();
    const viewport = document.documentElement.clientWidth;
    root.style.setProperty("--pt-bleed-left", `${Math.max(0, rect.left)}px`);
    root.style.setProperty("--pt-bleed-right", `${Math.max(0, viewport - rect.right)}px`);
  };

  const expandToFullWidth = (section) => {
    const root = section.querySelector(".products-tabs");
    if (!root || root.classList.contains("products-tabs--expanded")) return;
    updateBleed(section);
    root.classList.add("products-tabs--expanded");
  };

  const destroySliders = (section) => {
    const swiperEls = section.querySelectorAll(".products-tabs__layout");

    swiperEls.forEach((swiperEl) => {
      const swiperWrapper = section.querySelector(".products-tabs__list");
      const slides = section.querySelectorAll(".products-tabs__item");

      if (!swiperEl?.swiper || !slides.length || !swiperWrapper) return;

      swiperEl.swiper.destroy();

      swiperEl.classList.remove("swiper");
      swiperWrapper.classList.remove("swiper-wrapper");
      slides.forEach((slide) => slide.classList.remove("swiper-slide"));
    });
  };

  const toggleTab = (section) => {
    const tabsEls = section.querySelectorAll(".products-tabs__tab");
    const productsEls = section.querySelectorAll(".products-tabs__layout");

    const onToggleTab = (event, tab) => {
      event.preventDefault();
      if (tab.classList.contains("active")) return;
      const tabId = tab.dataset.productsTabId;

      tabsEls.forEach((el) => {
        el.classList.remove("active");
      });

      productsEls.forEach((el) => {
        el.classList.remove("active");

        if (el.swiper) {
          el.swiper.slideTo(0, 0);
        }
      });

      const productsActiveEl = section.querySelector(
        `.products-tabs__layout[data-products-tab-id="${tabId}"]`
      );
      tab.classList.add("active");
      productsActiveEl.classList.add("active");
    };

    tabsEls.forEach((tab) => {
      tab.addEventListener("click", (event) => onToggleTab(event, tab));

      tab.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          onToggleTab(event, tab);
        }
      });
    });
  };

  const initProductsTabs = (section) => {
    if (!section || !section?.classList.contains("products-tabs-section")) {
      return;
    }

    const sliderContainer = section.querySelector(".products-tabs");
    const cardsLayout = sliderContainer.dataset.layout || "grid";
    const cardsMobileLayout = sliderContainer.dataset.layoutMobile || "column";

    let currentLayout = null;

    const sectionResizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (sliderContainer.classList.contains("products-tabs--expanded")) {
          updateBleed(section);
        }

        let newLayout;

        if (entry.contentRect.width < 576) {
          newLayout = cardsMobileLayout === "slider" ? "slider" : "column";
        } else {
          newLayout = cardsLayout === "bar" ? "bar" : "grid";
        }

        if (newLayout !== currentLayout) {
          currentLayout = newLayout;

          destroySliders(section);

          if (newLayout === "slider" || newLayout === "bar") {
            initSliders(section, newLayout);
          }
        }
      });
    });

    sectionResizeObserver.observe(section);

    toggleTab(section);
  };

  const animateProductCards = (section) => {
    if (
      !section ||
      !section?.classList.contains("products-tabs-section") ||
      !section.querySelector(".animate-on-scroll")
    ) {
      return;
    }

    const productsTabsInner = section.querySelector(".products-tabs__inner");

    if (!productsTabsInner) return;

    /* Reveal unification Stage 4: shared observer; geometry preserved — old ScrollTrigger
       start "20% bottom" == reveal when 20% of the element crosses the viewport bottom.
       The per-card stagger (--prod-tabs-item-delay, set in initSliders) is untouched. */
    if (window.CoyReveal) {
      CoyReveal.observeAt(productsTabsInner, 0.2, 1);
    } else {
      productsTabsInner.classList.add("animated");
    }
  };

  initProductsTabs(document.currentScript.parentElement);

  animateProductCards(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initProductsTabs(event.target);
    animateProductCards(event.target);
  });
})();